import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { SIZE, ORIENTATION } from '../constants';
export class Page extends React.PureComponent {
    render() {
        const paddingTop = this.props.number > 1 && this.props.margins ? '13mm' : '0mm';
        let className = ' rpx-page-' + this.props.number;
        className += this.props.size === SIZE.A4 ? ' rpx-page-a4' : '';
        className += this.props.size === SIZE.A3 ? ' rpx-page-a3' : '';
        className += this.props.orientation === ORIENTATION.PORTRAIT ? ' rpx-page-portrait' : '';
        className += this.props.orientation === ORIENTATION.LANDSCAPE ? ' rpx-page-landscape' : '';
        return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
                        @media print {
                            .rpx-page-${this.props.number} {
                                padding-top: ${paddingTop};
                                grid-template-areas: ${this.props.areas};
                                grid-template-columns: ${this.props.columns || 'auto'};
                                grid-template-rows: ${this.props.rows || 'auto'};
                            }
                        }
                    ` }), _jsx("div", { className: 'rpx-page' + className, style: {
                        paddingTop,
                        gridTemplateAreas: this.props.areas,
                        gridTemplateColumns: this.props.columns,
                        gridTemplateRows: this.props.rows,
                        msGridColumns: this.props.columns,
                        msGridRows: this.props.rows,
                    }, children: this.props.children })] }));
    }
}
//# sourceMappingURL=page.js.map